import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const InternalServersConfigurationComponent = lazy(
  () => import('./internal-servers-configuration.tsx')
);

export const internalServersConfigurationRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <InternalServersConfigurationComponent />
      </Suspense>
    )
  }
];
